import {Component, OnInit, OnDestroy} from '@angular/core';
import {RegistriesService} from '../../../service';
import {TableReactiveUrlController} from "@amlCore/tableReactive";
import {ActivatedRoute, Router} from "@angular/router";
import {AlertService} from "@amlCore/components";
import {AccessJson} from "@amlCore/models";
import {RegistriesAccessEnum} from "@amlCore/enums";
import {RiskfactorClasses} from "../../../model";
import {TableService} from "@amlCore/services";
import {
  DictionaryService,
  UserService,
  VisitedService
} from "@amlCore/services";
import {RiskfactorEnum} from "../../../enums";
import { IDictionaryItem } from "@amlCore/interfaces"


@Component({
  selector: 'app-registry-riskfactor-classes',
  templateUrl: './riskfactorClasses.component.html'
})
export class RiskfactorClassesComponent extends TableReactiveUrlController implements OnInit, OnDestroy {
  currentType: RiskfactorEnum[]
  isShowVisited = true;
  typeClassList: IDictionaryItem<{ code: string, name: string }>[];

  constructor(private regSrv: RegistriesService,
              private userSrv: UserService,
              private alertSrv: AlertService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected dictSrv: DictionaryService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'className', dir: 'ASC'});
  }

  riskfactorClasses: Array<RiskfactorClasses> = [];

  access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_RISKGROUP);
    const routeData = this.activatedRoute.snapshot.data;
    if (routeData && routeData.type) {
      this.currentType = routeData.type;
    }
    this.activatedRoute.queryParams.subscribe(data => {
      this.loadList(this.syncParams(data));
    });
    this.typeClassList = this.dictSrv.getStaticData('typeClassList');
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  onPageChange(params) {
    this.navigate(this.getParams(params));
  }

  getRiskFactorTypeInfo(type: string) {
    return this.typeClassList.find((item: {code: string, name: string}) => item.code === type).name;
  }

  loadList(params?: any): void {
    const resParams: any = this.getParams(params);
    if('type' === resParams.sort){
      resParams.dir = resParams.dir == 'ASC' ? 'DESC' : 'ASC';
    }
    this.regSrv.getRiskfactorClasses(resParams, this.currentType).subscribe(data => {
      this.riskfactorClasses = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  onSearch() {
    const params = this.getSearchPage(this.filter);
    this.onPageChange(params);
  }

  edit(rClass: RiskfactorClasses) {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/riskfactorClassForm', rClass.id]);
  }

  remove(rClass: RiskfactorClasses) {
    this.alertSrv.clear();
    this.regSrv.deleteClasses(rClass.id).subscribe(data => {
      this.alertSrv.success(`Запись ${rClass.className} удалена!`);
      this.loadList();
    }, error => {
      this.alertSrv.clear();
      this.alertSrv.error(`Не удалось удалить запись ${rClass.className}. Возможно на этот класс ссылаются факторы риска.`);
      this.loadList();
    });
  }

  addNewItem() {
    this.router.navigate(['registries/riskfactorClassFormNew']);
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }
}
